const _undefined = void 0;

function onResize(el) {
  let callback = el.__resizeObserverCallback;
  let disabled = el.__resizeObserverDisabled || false;
  let observer = el.__resizeObserver;
  if (disabled) {
    observer?.disconnect();
    dsf.setObjAttr(el, "__resizeObserver", _undefined);
  } else {
    observer = new ResizeObserver(([entry]) => callback(entry));
    observer.observe(el);
    dsf.setObjAttr(el, "__resizeObserver", observer);
  }
}

export default {
  install(Vue) {
    /**
     * 指令 v-onresize
     */
    Vue.directive("onresize", {
      inserted(el, { value }) {
        if (!dsf.isFunction(value)) {
          throw new Error("resize-observer 指令的value属性必须是一个函数");
        }
        dsf.setObjAttr(el, "__resizeObserverCallback", value);
        setTimeout(() => onResize(el));
      },
      unbind(el) {
        el.__resizeObserver?.disconnect();
        dsf.setObjAttr(el, "__resizeObserver", _undefined);
        dsf.setObjAttr(el,"__resizeObserverCallback",_undefined);
      }
    });
    /**
     * 指令 v-onresize-disabled
     */
    Vue.directive("onresize-disabled", {
      inserted(el, { value }) {
        value = !!value && value != '0';
        dsf.setObjAttr(el, "__resizeObserverDisabled", value);
      },
      update(el, { value }) {
        value = !!value && value != '0';
        if (value !== el.__resizeObserverDisabled) {
          dsf.setObjAttr(el, "__resizeObserverDisabled", value);
          onResize(el);
        }
      }
    });
  }
};
